<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <!-- //header -->
      <SubHeader :title="headerTitle" />
      <!-- //header -->

      <div id="container" ref="container">
        <section id="contents">
          <div class="surveyWrap_start">
            <h5 class="subtitle">Non-real {{headerTitle}}</h5>
            <h3 class="title">{{welcome_text}}</h3>
            <div class="icon">
              <img :src="welcome_image" alt="비실시간퀴즈" />
            </div>
            <p>
              {{title}}를 시작하려면 아래의 버튼을 클릭하세요.
              <br />​ 정답은 최종 제출 전까지 수정이 가능합니다.​
            </p>
            <a href="#" v-if="!alreadyDone" title="퀴즈 시작하기" @click.prevent="goStart">
              <img src="@/assets/img/q_icon.png" alt="퀴즈 시작하기" />
              {{title}} 시작하기
            </a>
            <a href="#" v-if="alreadyDone" title="퀴즈 시작하기" @click.prevent="deny">
              <img src="@/assets/img/q_icon.png" alt="퀴즈 시작하기" />
              {{title}}를 제출하셨습니다
            </a>
          </div>
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import Gnb from "@/components/Gnb";
import router from "@/router";
import sideMixin from "@/components/SideMixin";
import { Constant } from "@/utils/const";
export default {
  mixins: [sideMixin],
  created() {
    let paperid = this.$route.params.paperid;
    let url = `${Constant.FullGetApi}/${paperid}`;
    this.$axios.get(url).then(resp => {
      this.welcome_text = resp.data.title;
      if (resp.data.welcome_image != null) {
        this.welcome_image = JSON.parse(resp.data.welcome_image).url;
      } else {
        this.welcome_image = require("@/assets/img/non-real_icon.png");
      }
      this.flag = resp.data.flag;
    });

    let nick = localStorage.getItem("default_info");
    url = `${Constant.NonItemApply}?user_nick=${nick}&paper_id=${paperid}`;
    this.$axios.get(url).then(resp => {
      let ret = resp.data;
      if (ret.length > 0) {
        if (ret[0].iscomp === "Y") {
          this.alreadyDone = true;
        } else {
          this.alreadyDone = false;
        }
      } else {
        this.alreadyDone = false;
      }
    });
  },
  components: { SubHeader },
  data() {
    return {
      welcome_text: "",
      welcome_image: "",
      flag: "",
      alreadyDone: false
    };
  },
  computed: {
    title() {
      return this.flag === "quiz" ? "퀴즈" : "설문";
    },
    headerTitle() {
      return this.flag === "quiz" ? "Quiz" : "Survey";
    }
  },

  methods: {
    goStart() {
      let paperid = this.$route.params.paperid;
      this.$router.push("/non/playground/" + paperid);
    },
    deny() {
      alert("이미 제출 하셨습니다");
    }
  }
};
</script>


<style lang="scss" scoped>
#contents {
  height: 100vh;
  padding-top: 55px;
}
.surveyWrap_start {
  padding: 30px 5% 0;
  text-align: center;
}

.surveyWrap_start h3 {
  margin-top: 12px;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  font-weight: 700;
}
.surveyWrap_start .img {
  margin-top: 25px;
  padding: 6px;
  background: #ffffff;
  box-shadow: 1px 1px 11px 5px rgba(0, 0, 0, 0.5);
}
.surveyWrap_start .img img {
  width: 100%;
}
.surveyWrap_start p {
  color: #ffffff;
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  line-height: 1.7em;
  margin-top: 25px;
}
.surveyWrap_start a {
  margin: 25px 0 0;
  display: block;
  background: #193231;
  height: 45px;
  line-height: 45px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  border-radius: 9px;
  box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, 0.4);
}
.surveyWrap_start a img {
  width: 25px;
  margin-right: 8px;
}
.surveyWrap_start .icon {
  margin-top: 35px;
  margin-bottom: 44px;
}
.surveyWrap_start .icon img {
  width: 25%;
}
</style>